// 导入所有组件
const publicComponents = [
	"van-beauty",
    "van-one-pic",
    "van-scenic",
    "van-two-pic",
    "van-two-slide",
    "van-three-slide",
    "lime-painter"
];

const components = publicComponents.map(t => {
  var str = require("./" + t + "/index.js");
  return str.default;
});
const install = function(vue) {
  /* istanbul ignore if */
  if (install.installed) return;
  /*eslint-disable*/
  components.map((component) => {
    vue.component(component.name, component); //component.name 此处使用到组件vue文件中的 name 属性
  });
};
/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
};

export default {
  install,
  ...publicComponents
}